import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // Pagination
    currentPage: 1,
    maxPages: 1,
    totalCount: 0,
    
    // Sorting
    sortBy: null,
    sortDirection: null, // 'ASC' or 'DESC'
    
    // Search
    searchValue: '',
    keyword: '',
    
    // Tab state
    pageTab: 'accepted', // 'accepted', 'pending', 'blocked'
    
    // Counts for tabs
    acceptedCount: 0,
    pendingCount: 0,
    blockedCount: 0,
    
    // Selection
    checkedItems: [],
    
    // Modals
    addModalOpen: false,
    editModalOpen: false,
    detailPanelOpen: false,
    
    // Selected organizer for detail/edit
    selectedOrganizer: null,
    editedOrganizer: null,
    
    // Refresh trigger
    needRefresh: false,

    // Filters
    filters: {
        dateFrom: '',
        dateTo: '',
        status: '',
    },
};

const organizersSlice = createSlice({
    name: 'organizers',
    initialState,
    reducers: {
        // Pagination
        setPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setMaxPages: (state, action) => {
            state.maxPages = action.payload;
        },
        setTotalCount: (state, action) => {
            state.totalCount = action.payload;
        },
        
        // Sorting
        setSorting: (state, action) => {
            const { sortBy, sortDirection } = action.payload;
            state.sortBy = sortBy;
            state.sortDirection = sortDirection;
        },
        
        // Search
        setSearchValue: (state, action) => {
            state.searchValue = action.payload;
        },
        setKeyword: (state, action) => {
            state.keyword = action.payload;
        },
        
        // Tab
        setPageTab: (state, action) => {
            state.pageTab = action.payload;
            state.currentPage = 1;
            state.checkedItems = [];
        },
        
        // Counts
        setAcceptedCount: (state, action) => {
            state.acceptedCount = action.payload;
        },
        setPendingCount: (state, action) => {
            state.pendingCount = action.payload;
        },
        setBlockedCount: (state, action) => {
            state.blockedCount = action.payload;
        },
        
        // Selection
        setCheckedItems: (state, action) => {
            state.checkedItems = action.payload;
        },
        toggleCheckedItem: (state, action) => {
            const id = action.payload;
            if (state.checkedItems.includes(id)) {
                state.checkedItems = state.checkedItems.filter(item => item !== id);
            } else {
                state.checkedItems.push(id);
            }
        },
        clearCheckedItems: (state) => {
            state.checkedItems = [];
        },
        
        // Modals
        toggleAddModal: (state) => {
            state.addModalOpen = !state.addModalOpen;
        },
        toggleEditModal: (state) => {
            state.editModalOpen = !state.editModalOpen;
        },
        toggleDetailPanel: (state) => {
            state.detailPanelOpen = !state.detailPanelOpen;
        },
        closeDetailPanel: (state) => {
            state.detailPanelOpen = false;
            state.selectedOrganizer = null;
        },
        
        // Selected organizer
        setSelectedOrganizer: (state, action) => {
            state.selectedOrganizer = action.payload;
            state.detailPanelOpen = true;
        },
        setEditedOrganizer: (state, action) => {
            state.editedOrganizer = action.payload;
        },
        
        // Refresh
        toggleNeedRefresh: (state) => {
            state.needRefresh = !state.needRefresh;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
            state.currentPage = 1;
            state.checkedItems = [];
        },
        clearFilters: (state) => {
            state.filters = {
                dateFrom: '',
                dateTo: '',
                status: '',
            };
            state.currentPage = 1;
            state.checkedItems = [];
        },
        
        // Reset
        resetState: (state) => {
            return initialState;
        },
    },
});

export const {
    setPage,
    setMaxPages,
    setTotalCount,
    setSorting,
    setSearchValue,
    setKeyword,
    setPageTab,
    setAcceptedCount,
    setPendingCount,
    setBlockedCount,
    setCheckedItems,
    toggleCheckedItem,
    clearCheckedItems,
    toggleAddModal,
    toggleEditModal,
    toggleDetailPanel,
    closeDetailPanel,
    setSelectedOrganizer,
    setEditedOrganizer,
    toggleNeedRefresh,
    resetState,
    setFilters,
    clearFilters,
} = organizersSlice.actions;

export default organizersSlice.reducer;



